import { render, staticRenderFns } from "./PiHoleTrafficV6.vue?vue&type=template&id=a8c32a16"
import script from "./PiHoleTrafficV6.vue?vue&type=script&lang=js"
export * from "./PiHoleTrafficV6.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports